import React from 'react';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CopyrightIcon from '@mui/icons-material/Copyright';
import "../../component/styles/styles.scss";
import logo from "../../assets/images/abstract.png";

export default function Footer() {
    return (
        <footer>
            <div className='footer-wrapper'>
                <p>ShadeSense <img src={logo} alt='' /> <span><CopyrightIcon sx={{ fontSize: "13px" }} /></span></p>
                <p>Made with <FavoriteIcon sx={{ color: "red", fontSize: "13px" }} /> by <span><a href='https://chandanbaruah.com/' target='_blank' rel='noreferrer'>Chandan Baruah</a></span> </p>
            </div>
        </footer>
    )
}
